import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import MobikodeProducts from '../Components/products/MobikodeProducts'
import { Helmet } from "react-helmet-async";
function Products() {
    return (
        <div>
            <Helmet>
    <title>
        Mobikode Products | Innovative Digital & Enterprise Solutions
    </title>

    <meta
        name="description"
        content="Explore Mobikode's innovative digital products and enterprise solutions designed to simplify operations, improve efficiency, automate workflows, and support business growth."
    />

    <meta
        name="keywords"
        content="Mobikode Products, Digital Products, Enterprise Software Products, Business Software Solutions, Digital Transformation Products, Enterprise Solutions, Business Automation Software, Workplace Management Software, IT Solutions, Digital Solutions, Mobikode Software Products"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/products"
    />

    <meta
        property="og:title"
        content="Mobikode Products | Innovative Digital & Enterprise Solutions"
    />

    <meta
        property="og:description"
        content="Discover Mobikode's digital and enterprise products built to simplify business operations, automate processes, improve productivity, and enable smarter growth."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/products"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/products/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Mobikode Products | Innovative Digital & Enterprise Solutions"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's digital products and enterprise solutions designed to improve efficiency, simplify operations, and support business growth."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/products/bg1.png"
    />
</Helmet>
            <WhoHero
                title="Products"
                text="Technology. Transformation. Trust."
                imgData="/assets/products/bg1.png"
            />
            <MobikodeProducts />
        </div>
    )
}

export default Products
